import styled from "@emotion/styled"

const ContentContact = styled('div')(() => ({
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position:'absolute',
    top:'100px',
}))

export default ContentContact